import type { Ref } from 'react';
import { Tooltip } from './ButtonControl';

import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from '../lib/cx';

export type DashboardProps = HTMLAttributes<HTMLElement>;

export function Dashboard(
  { ref, className, children, ...rest }: DashboardProps & { ref?: Ref<HTMLElement> },
) {
  return (
    <main ref={ref} className={cx('dashboard', className)} {...rest}>
      {children}
    </main>
  );
}

export interface DashColumnProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  title: ReactNode;
  count?: number | ReactNode;
  action?: ReactNode;
}

export function DashColumn(
  { ref, title, count, action, className, children, ...rest }: DashColumnProps & { ref?: Ref<HTMLDivElement> },
) {
  return (
    <div ref={ref} className={cx('dash-column', className)} {...rest}>
      <div className="dash-column-head">
        <Tooltip><h3 className="dash-column-title" title={typeof title === 'string' ? title : undefined}>
          <span className="dash-column-title-text">{title}</span>
        </h3></Tooltip>
        {count != null && <span className="dash-column-count">{count}</span>}
      </div>
      {action ? <div className="dash-column-action">{action}</div> : null}
      <div className="dash-column-body">{children}</div>
    </div>
  );
}
